module.exports = __webpack_public_path__ + "static/media/mexicoflag.b530ede5.png";